import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {

  private baseurl: string = '/group';

  public list: any = [];

  public list_enabled: any = [];

  constructor(private _httpClient: HttpClient) {
  }

  async getList(defRet: any = []): Promise<any> {
    return this._httpClient.get(this.baseurl + '?enabled=2').toPromise()
      .then((response: any) => {
        this.list = response;
        this.list_enabled = response.filter((group: any) => Boolean(group.enabled));
        return response;
      })
      .catch(err => {
        console.error(err);
        return defRet;
      });
  }

  async get(id: number) {
    return this._httpClient.get(this.baseurl + '/' + id).toPromise()
      .catch(err => {
        console.error(err);
        return {};
      });
  }

  async create(data: any = {}) {
    return this._httpClient.post(this.baseurl, data).toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: any = {}) {
    return this._httpClient.put(this.baseurl + '/' + id, data).toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async delete(id: number) {
    return this._httpClient.delete(this.baseurl + '/' + id).toPromise()
      .then(async response => {
        await this.getList();
        this.list = response;
        return response;
      });
  }
}